module.exports = {"AS9100":"AS9100","ISO14001":"ISO14001","ISO27001":"ISO27001","ISO9001":"ISO9001","ITAR Registered":"ITAR Registered","Mil-I-45208":"Mil-I-45208","Mil-I-45662":"Mil-I-45662","Mil-I-48208A":"Mil-I-48208A","Mil-Q-9858":"Mil-Q-9858","NADCAP":"NADCAP","Other Quality System":"Other Quality System","TS 16949":"TS 16949"}


//////////////////
// WEBPACK FOOTER
// ./src/config/qualityCertifications.json
// module id = 5418
// module chunks = 1